import React, { FC, useRef } from 'react';

import { MediaQuery } from '@rover/kibble/styles';
import { BreakpointMatch, withMatchMedia } from '@rover/react-lib/src/hooks/useMatchMedia';
import useNotificationsCenterShim from '@rover/shared/js/hooks/useNotificationsCenterShim';

import NotificationsCenter from './NotificationsCenter';
import useNotificationsCenterEffects from './useNotificationsCenterEffects';

type Props = {
  matchesMediaQuery: BreakpointMatch;
  implementDjangoHacks: boolean;
};

export const NotificationsCenterContainer: FC<Props> = ({
  matchesMediaQuery: isMobileBreakpoint,
  implementDjangoHacks = false,
}) => {
  const buttonRef = useRef<HTMLButtonElement | null>(null);
  const { unreadCountDisplay } = useNotificationsCenterShim();
  const { handleButtonClick, isOpen } = useNotificationsCenterEffects(isMobileBreakpoint);
  return (
    <NotificationsCenter
      handleButtonClick={handleButtonClick}
      isOpen={isOpen}
      buttonRef={buttonRef}
      isMobileBreakpoint={isMobileBreakpoint}
      unreadCountDisplay={unreadCountDisplay}
      implementDjangoHacks={implementDjangoHacks}
    />
  );
};

export default withMatchMedia(MediaQuery.XS.getBreakpointString())(NotificationsCenterContainer);
